import { graphql } from 'src/generated';

export const tableColumnFragment = graphql(`
  fragment TableColumn on TableColumns {
    _id
    system
    resizable
    tableId
    field
    type
    valueType
    minWidth
    label
    options {
      ...TableColumnOption
    }
    tableRef
    canNotify
    syncLink
    columnRef
    columnRefValue {
      _id
      system
      resizable
      tableId
      field
      type
      valueType
      minWidth
      label
      tableRef
      columnRef
      options {
        ...TableColumnOption
      }
    }
    linkingColumnRef
    function {
      operator
      columns
      result
    }
    defaultValue
    aggregator
    format
  }
`);

export const tableColumnOptionFragment = graphql(`
  fragment TableColumnOption on TableColumnOption {
    _id
    label
    color
    order
    system
    statusGroup
  }
`);

export const tableFragment = graphql(`
  fragment Table on Table {
    _id
    name
    board
    order
  }
`);

export const tableRowFragment = graphql(`
  fragment tableRow on TableRow {
    _id
    rowId
    tableId
    order
    ownerId
    unreadComments
    hasComments
    hasDescription
    columns {
      columnId
      value
      linkValue
    }
  }
`);

export const tableRowHistoryFragment = graphql(`
  fragment tableRowHistory on TableRowHistory {
    _id
    rowId
    tableId
    workspace
    columnId
    author
    after
    before
    data
    createdAt
  }
`);

export const tableViewSortFragment = graphql(`
  fragment tableViewSortFragment on TableViewSortInput {
      column
      direction
  }
`);

export const tableViewFragment = graphql(`
  fragment tableView on TableView {
    _id
    title
    type
    creatorId
    groupBy
    filter
    order
    access
    showSummary
    sortBy {
      ...tableViewSortFragment
    }
    participants {
      ... on WorkspaceParticipantUser {
        user
      }
      ... on WorkspaceParticipantTeam {
        team
      }
    }
  }
`);

export const tableViewColumFragment = graphql(`
  fragment TableViewColumn on TableViewColumn {
    _id
    columnId
    order
    fixed
    width
    hidden
  }
`);

export const tableViewDetailsFragment = graphql(`
  fragment tableViewDetails on TableView {
    ...tableView

    columns {
      ...TableViewColumn
    }
  }
`);

export const boardRolesFragment = graphql(`
  fragment BoardRoles on Board {
    roles {
      admin
      member
      viewer
      edit_all
      edit_own
      edit_unassigned
      view_all
      view_own
      view_unassigned
    }
  }
`);

export const boardParticipantsFragment = graphql(`
  fragment BoardParticipants on Board {
    participants {
      ... on WorkspaceParticipantUser {
        user
      }
      ... on WorkspaceParticipantTeam {
        team
      }
    }
  }
`);

export const tableRowRoom = graphql(`
  fragment tableRowRoom on TableRowRoomComment {
    _id
    rowId
    boardId
    tableId
    name
    type
    workspace
    createdBy
    participants {
      ... on WorkspaceParticipantUser {
        user
      }
      ... on WorkspaceParticipantTeam {
        team
      }
    }
    lastReadMessage
    hasUnreadMessages
  }
`);

export const tableRowComment = graphql(`
  fragment tableRowComment on TableRowComment {
    _id
    rowId
    tableId
    author
    edited
    content
    contentType
    mimeType
    mediaRef
    fileName
    fileSize
    mediaThumbnailRef
    mentions
    reactions {
      ... on TableRowCommentReaction {
        emoji
        users
      }
    }
    createdAt
    replyTo {
      _id
      rowId
      tableId
      author
      content
      contentType
      createdAt
    }
  }
`);
